module.exports = __webpack_public_path__ + "static/media/rev3.ec019e55.png";